import React from 'react';

import { Box, Breadcrumbs as MaterialBreadcrumbs, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import AnimatedSkeleton from '../AnimatedSkeleton';
import useStyles from './styles';

export type Crumb = {
  url?: string;
  title: string;
};

interface BreadcrumbsProps {
  crumbs: Crumb[];
  className?: string;
  loading?: boolean;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  crumbs,
  className = '',
  loading = false,
  ...rest
}) => {
  const classes = useStyles();

  if (loading) {
    return (
      <LoadingWrapper className={className}>
        <AnimatedSkeleton xs="24px" />
      </LoadingWrapper>
    );
  }

  if (crumbs.length === 0) return null;

  return (
    <Box className={cx(classes.breadcrumbs, className)} data-testid={rest['data-testid']}>
      <MaterialBreadcrumbs aria-label="breadcrumb">
        {crumbs.map((item, i) => {
          if (i !== crumbs.length - 1) {
            return (
              <Link data-testid="breadcrumbLink" key={item.url} to={item.url}>
                <Typography className={classes.crumb}>{item.title}</Typography>
              </Link>
            );
          } else {
            return (
              <Typography
                data-testid="breadcrumbCurrent"
                key={item.title}
                className={classes.lastCrumb}
              >
                {item.title}
              </Typography>
            );
          }
        })}
      </MaterialBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;

const LoadingWrapper = styled('div')`
  display: flex;
  max-width: 460px;
`;
